import { trace } from 'owa-trace';
import type { Suggestion } from 'owa-userdataservice';
import { SonoraEntityType, SonoraPerson } from 'owa-editor-sonora-types';

const PEOPLE_KEY_NAME = 'People';

export default function parseVivaTopicPeopleSuggestions(
    suggestion: Suggestion
): SonoraPerson[] | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);

        // There may be multiple topics, and each topic has its own set of related people.
        const suggestions: SonoraPerson[] = [];
        if (data?.Value) {
            data.Value.forEach(userDataInfo => {
                if (userDataInfo.RelatedResourcesMap?.length > 0) {
                    userDataInfo.RelatedResourcesMap.forEach(relatedResourcesMap => {
                        if (relatedResourcesMap.Key === PEOPLE_KEY_NAME) {
                            relatedResourcesMap.Value.forEach(person =>
                                suggestions.push(<SonoraPerson>{
                                    type: SonoraEntityType.VivaTopicPerson,
                                    displayName: person.DisplayName,
                                    emailAddress: person.EmailAddress,
                                    userPrincipalName: person.UserPrincipalName,
                                    relatedTopicName: userDataInfo.DisplayName,
                                })
                            );
                        }
                    });
                }
            });

            return suggestions;
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseVivaTopicPersonSuggestions] Error: ${error}`);
    }
    return undefined;
}
